// Image assets from Figma design
// Note: These URLs expire after 7 days. Download and host locally for production.

import melomint from "./images/melomint.png";
import navLogo from "./images/nav_logo.png";
import heroImg from "./images/hero image.jpg";
import aboutImg from "./images/about image.jpg";
import visionImg1 from "./images/vision_1.jpg";
import visionImg2 from "./images/vision_2.jpg";
import visionImg3 from "./images/vision_4.jpg";
import visionImg4 from "./images/vision_3.jpg";
import missionImg from "./images/mission.jpg";
import what2_2_1 from "./images/what-we-do-item-2 2-1.png";
import what2_2_2 from "./images/what-we-do-item-2 2-2.png";
import what2_2 from "./images/what-we-do-item-2 2.png";
import what2_3 from "./images/what-we-do-item-2 3.png";
import what2_5 from "./images/what-we-do-item-2 5.png";
import socialIcons from "./images/Social Icons.png";
import socialIcons1 from "./images/Social Icons-1.png";
import socialIcons2 from "./images/Social Icons-2.png";
import logo_2 from "./images/logo_2.png";

export const images = {
  logo: navLogo,
  logo2: logo_2,
  heroBackground: heroImg,
  aboutImage: aboutImg,
  visionImage1: visionImg1,
  visionImage2: visionImg2,
  visionImage3: visionImg3,
  visionImage4: visionImg4,
  missionImage: missionImg,
  whatWeDoItem1: what2_2_1,
  whatWeDoItem2: what2_2_2,
  whatWeDoItem3: what2_2,
  whatWeDoItem4: what2_3,
  whatWeDoItem5: what2_5,
  whyChooseImage: "https://www.figma.com/api/mcp/asset/71cc3a5f-e0e7-4be4-b1b7-4788ac67ea5d",

  // Icons
  partnersIcon: "https://www.figma.com/api/mcp/asset/99abc049-13de-41ff-beb6-be841bd7d3de",
  checkIcon: "https://www.figma.com/api/mcp/asset/753b50b8-01ef-49ac-b8a0-559e5c227c05",
  processedIcon: "https://www.figma.com/api/mcp/asset/f4c456df-c8a3-46fa-a0e6-7754d1fe3d9b",
  checkIconWhite: "https://www.figma.com/api/mcp/asset/0002760d-7266-4994-85c8-a74a956543fc",
  projectsIcon: "https://www.figma.com/api/mcp/asset/6e363d51-c123-4e0c-aa3c-0b37bb05ded2",

  // Social icons
  socialFacebook: socialIcons,
  socialTwitter: socialIcons1,
  socialLinkedin: socialIcons2,

  // Footer
  footerLogo: melomint,
};

export default images;
